import { render, staticRenderFns } from "./JobsList.vue?vue&type=template&id=1ffbffda&"
import script from "./JobsList.vue?vue&type=script&lang=js&"
export * from "./JobsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports